// extracted by css-extract-rspack-plugin
export default {"PageDivider":"PageDivider-module__PageDivider__HA_25"};